export default "__VITE_ASSET__KgWzA$NE__"